import * as React from 'react';

interface IInputRadio {
    options: {
        label: string;
        value: any;
        image: string;
    }[];
    name: string;
    selectedValue: any;
    setValue: (value) => void;
    disabled: boolean;
}

const InputRadioWithImage: React.SFC<IInputRadio> = ({
    options,
    selectedValue,
    setValue,
    name,
    disabled
}) => {
    return (
        <div className="input-group mt-2">
            {options.map((o, i) => {
                const isChecked = o.value == selectedValue;
                return (
                    <div
                        className="radio-custom-icon"
                        data-test={`radio-${o.label}`}
                        onClick={() => !disabled && setValue(o.value)}
                    >
                        <input type="radio" name={name} checked={isChecked} />
                        <label
                            className={`input-radio ${
                                disabled ? 'disabled' : ''
                            }`}
                            key={name + i}
                        >
                            {o.label}
                            <img src={o.image} />
                        </label>
                    </div>
                );
            })}
        </div>
    );
};

export default InputRadioWithImage;
